import { reorderCategoriesMutation } from '../../../lib/graphql';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';

// Category Studio (A2): persist drag & drop ordering of categories. Silent on success
// (the UI already reflects the new order optimistically); only surfaces errors.
const reorderCategories = (orderedIds) => {
    return async (dispatch, getState, { client }) => {
        try {
            const { data } = await client.mutate({
                mutation: reorderCategoriesMutation,
                variables: { orderedIds },
            });

            if (data?.reorderCategories?.status === 200) {
                return { status: 200 };
            }
            showToaster({ messageId: 'errorMessage', requestContent: data?.reorderCategories?.errorMessage, toasterType: 'error' });
            return { status: 400 };
        } catch (err) {
            showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
            return { status: 400 };
        }
    };
};

export default reorderCategories;
